import { z } from 'zod'

export const upsertPrivateNoteSchema = z.object({
  content: z.string().max(10000),
})

export type UpsertPrivateNoteInput = z.infer<typeof upsertPrivateNoteSchema>
